import React, { useState } from "react";
import { Routes } from "../constants";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { JWT } from "../Components/shared";

export default function SideBar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const splitLocation = pathname.split("/");
  const role = localStorage.getItem("userRole");
  const [show, setShow] = useState(false);

  const handleLogOut = () => {
    setShow(true);
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to Logout?",
      showCancelButton: true,
      confirmButtonColor: "#009462",
      cancelButtonColor: "#314a5f",
      confirmButtonText: `Yes`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let email = localStorage.getItem("RememberMeEmail");
          let password = localStorage.getItem("Password");
          localStorage.clear();
          if (email != null && password != null) {
            localStorage.setItem("RememberMeEmail", email);
            localStorage.setItem("Password", password);
          }
          JWT.removeJWT();
          navigate("/");
          toast.dismiss();
          toast.success("Logged out successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
        } catch (err) {
          console.log(err);
          Swal.fire("FAQ!", "Something went wrong!", "error");
          return Promise.reject(err);
        }
      }
    });
  };

  return (
    <React.Fragment>
      <aside id="sidebar" className="sidebar">
        <ul className="sidebar-nav" id="sidebar-nav">
          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname === "/dashboard" ? "collapsed active" : ""
              } `}
              to={Routes.DASHBOARD}
            >
              <i
                className={`bi bi-grid ${
                  pathname === "/dashboard" ? "collapsed active" : ""
                } `}
              />
              <span>Dashboard</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${
                splitLocation[1] === "session" ? "collapsed active" : ""
              } `}
              to={Routes.SESSION}
            >
              <i
                className={`bi bi-menu-button-wide ${
                  splitLocation[1] === "session" ? "collapsed active" : ""
                } `}
              ></i>
              <span>Session Management</span>
            </Link>
          </li>

          {role === "admin" && (
            <li className="nav-item">
              <Link
                className={`nav-link ${
                  splitLocation[1] === "user" ? "collapsed active" : ""
                } `}
                to={Routes.USER}
              >
                <i
                  className={`bi bi-people-fill ${
                    splitLocation[1] === "user" ? "collapsed active" : ""
                  } `}
                ></i>
                <span>Users Mangement</span>
              </Link>
            </li>
          )}

          <li className="nav-item">
            <Link
              className={`nav-link ${
                splitLocation[1] === "question" ? "collapsed active" : ""
              } `}
              to={Routes.QUESTION}
            >
              <i
                className={`bi bi-question-circle ${
                  splitLocation[1] === "question" ? "collapsed active" : ""
                } `}
              ></i>
              <span>Question Management</span>
            </Link>
          </li>

          <li className="nav-item">
            <Link
              className={`nav-link ${
                splitLocation[1] === "audio_management"
                  ? "collapsed active"
                  : ""
              } `}
              to={Routes.FAQ}
            >
              <i
                className={`fa-solid fa-file ${
                  splitLocation[1] === "audio_management"
                    ? "collapsed active"
                    : ""
                } `}
              ></i>
              <span>Audio Management</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${
                splitLocation[1] === "video_management"
                  ? "collapsed active"
                  : ""
              } `}
              to={Routes.VIDEO}
            >
              <i
                className={`fa-solid fa-photo-film ${
                  splitLocation[1] === "video_management"
                    ? "collapsed active"
                    : ""
                } `}
              ></i>
              <span>Video Management</span>
            </Link>
          </li>

          <li className="nav-item">
            <Link
              className={`nav-link ${
                splitLocation[1] === "keyValue" ? "collapsed active" : ""
              } `}
              to={Routes.KEY_VALUE}
            >
              <i
                className={`fa-solid fa-arrow-right-arrow-left ${
                  splitLocation[1] === "keyValue" ? "collapsed active" : ""
                } `}
              ></i>
              <span>Key / Value Management</span>
            </Link>
          </li>

          <li className="nav-item">
            <Link className="nav-link collapsed" to="#" onClick={handleLogOut}>
              <i className="bi bi-box-arrow-right"></i>
              <span>Logout</span>
            </Link>
          </li>
        </ul>
      </aside>
    </React.Fragment>
  );
}
